import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Div = styled.div`
  position: relative;

  .page_title {
    flex: auto;
    margin: 20px 0 0 2%;
    font-size: 21px;
    font-weight: normal;
    font-family: 'Roboto';
    color: #777;
  }

  .selects_bar {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    position: absolute;
    top: 12px;
    right: 2%;
    width: 98%;
    z-index: 5;
  }

  .tools_bar {
    display: flex;
    margin-right: 2%;
    flex-direction: row;
    width: 98%;
    align-items: center;
    justify-content: flex-end;
  }

  .range_picker {
    border: none;
    border-radius: 8px;
    background-color: #fff;
    height: 38px;
    width: 230px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
    margin-left: 12px;

    &:hover {
      cursor: pointer;
      border: none;
      box-shadow: 0 0 4px -1px rgba(0, 0, 0, 0.1);
    }
  }

  .action_button {
    background-color: ${COLORS.transparentDark};
    margin: 8px 2% 0 0;
    padding: 10px 30px;
    border-radius: 8px;
    font-size: 13px;
    color: #444;
    text-decoration: none;
    transition: background-color 200ms ease-in-out;

    &:first-of-type {
      margin-left: 2%;
    }

    :focus {
      outline: none;
    }

    :hover:not(:disabled) {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }

    :disabled {
      cursor: not-allowed;
      background-color: #f3f3f3;
      color: #bebebe;
    }
  }

  .search {
    width: 425px;
    margin-top: 8px;
    .ant-input-affix-wrapper {
      border-radius: 8px !important;
    }

    .ant-btn,
    .ant-btn-primary,
    .ant-btn-loading,
    .ant-input-search-button {
      border-radius: 8px !important;
    }

    .ant-btn,
    .ant-btn-primary,
    .ant-input-search-button {
      background: ${({ theme }) => theme.primary};

      :hover {
        background-color: ${({ theme }) => theme.selectedDiv};
        color: ${({ theme }) => theme.primary};
      }
    }
  }

  .div_selected {
    display: flex;
    flex-direction: row;
    width: 230px;
  }

  .selected_button {
    background-color: ${({ theme }) => theme.hoveredDiv};
    margin: 8px 2% 0 0;
    padding: 10px 30px;
    border-radius: 8px;
    font-size: 13px;
    color: #444;
    text-decoration: none;
    transition: background-color 200ms ease-in-out;

    &:first-of-type {
      margin-left: 2%;
    }

    :focus {
      outline: none;
    }

    :hover {
      background-color: ${({ theme }) => theme.primary};
      color: #fff;
    }
  }

  .close_select_button {
    width: 23px;
    height: 23px;
    margin-top: 17px;
    color: ${COLORS.red};

    &:hover {
      opacity: 0.6;
    }
  }
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;
